"use client"

import React, { createContext, useContext } from "react"

import type { ClientEnv } from "./client-base"

const EnvContext = createContext<ClientEnv | undefined>(undefined)

export interface EnvProviderProps {
  env: ClientEnv
  children: React.ReactNode
}

export function EnvProvider({ env, children }: EnvProviderProps) {
  return <EnvContext.Provider value={env}>{children}</EnvContext.Provider>
}

export function useEnv(): ClientEnv {
  const env = useContext(EnvContext)
  if (!env) {
    throw new Error("useEnv must be used within an EnvProvider")
  }
  return env
}
